import React from "react";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function ConfettieBg() {
  return (
    <Svg
      width="375"
      height="116"
      viewBox="0 0 375 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_confetti)">
        <Path
          d="M57.0313 53.027C53.6286 42.8553 43.1204 37.202 36.2076 39.5146C29.2947 41.8272 24.3036 52.6655 27.7064 62.8372C30.856 72.2524 40.4001 77.6878 46.9656 76.7178C46.9183 76.8002 46.8871 76.8908 46.8738 76.9848L46.673 78.6593C46.6577 78.7869 46.6753 78.9163 46.7241 79.0353C46.7729 79.1542 46.8513 79.2587 46.9518 79.3388C47.0523 79.419 47.1717 79.4721 47.2985 79.4931C47.4253 79.5141 47.5554 79.5024 47.6764 79.459L51.0585 78.2463C51.1795 78.2029 51.2874 78.1293 51.372 78.0325C51.4566 77.9357 51.515 77.8188 51.5417 77.6931C51.5684 77.5673 51.5625 77.4368 51.5246 77.314C51.4867 77.1911 51.4181 77.08 51.3251 76.9912L50.106 75.8258C50.0627 75.7862 50.0148 75.7518 49.9634 75.7233C55.8193 72.5675 60.1879 62.4627 57.0313 53.027Z"
          fill="#F2F2F2"
        />
        <Path
          d="M44.7128 45.5432C47.5386 47.0016 49.6967 49.4893 50.7415 52.4928C51.7864 55.4962 51.6382 58.7862 50.3276 61.6836C50.035 62.3498 51.1112 62.7001 51.4019 62.0383C52.7779 58.9033 52.9179 55.364 51.7937 52.1301C50.6695 48.8963 48.3643 46.207 45.3404 44.6016C44.7021 44.2634 44.0698 45.2025 44.7128 45.5432Z"
          fill="white"
        />
        <Path
          d="M356.883 39.027C353.481 28.8553 342.972 23.202 336.06 25.5146C329.147 27.8272 324.156 38.6655 327.558 48.8372C330.708 58.2524 340.252 63.6878 346.818 62.7178C346.77 62.8002 346.739 62.8908 346.726 62.9848L346.525 64.6593C346.51 64.7869 346.527 64.9163 346.576 65.0353C346.625 65.1542 346.703 65.2587 346.804 65.3388C346.904 65.419 347.024 65.4721 347.151 65.4931C347.277 65.5141 347.407 65.5024 347.528 65.459L350.911 64.2463C351.032 64.2029 351.139 64.1293 351.224 64.0325C351.309 63.9357 351.367 63.8188 351.394 63.6931C351.42 63.5673 351.415 63.4368 351.377 63.314C351.339 63.1911 351.27 63.08 351.177 62.9912L349.958 61.8258C349.915 61.7862 349.867 61.7518 349.815 61.7233C355.671 58.5675 360.04 48.4627 356.883 39.027Z"
          fill="#F2F2F2"
        />
        <Path
          d="M344.565 31.5442C347.391 33.0026 349.549 35.4903 350.594 38.4937C351.638 41.4972 351.49 44.7872 350.18 47.6845C349.887 48.3507 350.963 48.7011 351.254 48.0392C352.63 44.9043 352.77 41.365 351.646 38.1311C350.522 34.8973 348.216 32.208 345.192 30.6026C344.554 30.2644 343.922 31.2035 344.565 31.5442Z"
          fill="white"
        />
        <Path
          d="M100.421 24.027C97.0182 13.8553 86.5101 8.20202 79.5972 10.5146C72.6844 12.8272 67.6932 23.6655 71.096 33.8372C74.2457 43.2524 83.7897 48.6878 90.3553 47.7178C90.3079 47.8002 90.2767 47.8908 90.2634 47.9848L90.0627 49.6593C90.0474 49.7869 90.065 49.9163 90.1138 50.0353C90.1625 50.1542 90.2409 50.2587 90.3415 50.3388C90.442 50.419 90.5613 50.4721 90.6882 50.4931C90.815 50.5141 90.9451 50.5024 91.0661 50.459L94.4481 49.2463C94.5691 49.2029 94.6771 49.1293 94.7616 49.0325C94.8462 48.9357 94.9046 48.8188 94.9313 48.6931C94.9581 48.5673 94.9522 48.4368 94.9143 48.314C94.8764 48.1911 94.8077 48.08 94.7148 47.9912L93.4957 46.8258C93.4523 46.7862 93.4044 46.7518 93.353 46.7233C99.2089 43.5675 103.578 33.4627 100.421 24.027Z"
          fill="#F2F2F2"
        />
        <Path
          d="M88.1024 16.5432C90.9283 18.0016 93.0863 20.4893 94.1312 23.4928C95.176 26.4962 95.0278 29.7862 93.7172 32.6836C93.4246 33.3498 94.5008 33.7001 94.7915 33.0383C96.1676 29.9033 96.3075 26.364 95.1834 23.1301C94.0592 19.8963 91.754 17.207 88.73 15.6016C88.0918 15.2634 87.4594 16.2025 88.1024 16.5432Z"
          fill="white"
        />
        <Path
          d="M178.728 62.971C179.176 62.971 179.538 62.608 179.538 62.1603C179.538 61.7126 179.176 61.3496 178.728 61.3496C178.28 61.3496 177.917 61.7126 177.917 62.1603C177.917 62.608 178.28 62.971 178.728 62.971Z"
          fill="#CCCCCC"
        />
        <Path
          d="M177 95.491C177.884 95.491 178.601 94.774 178.601 93.8896C178.601 93.0051 177.884 92.2881 177 92.2881C176.116 92.2881 175.399 93.0051 175.399 93.8896C175.399 94.774 176.116 95.491 177 95.491Z"
          fill="#CCCCCC"
        />
        <Path
          d="M69.1894 97.1272C69.7005 97.1272 70.1148 96.7128 70.1148 96.2018C70.1148 95.6907 69.7005 95.2764 69.1894 95.2764C68.6783 95.2764 68.264 95.6907 68.264 96.2018C68.264 96.7128 68.6783 97.1272 69.1894 97.1272Z"
          fill="#CCCCCC"
        />
        <Path
          d="M164.248 74.1723C164.801 74.1723 165.25 73.7236 165.25 73.1701C165.25 72.6166 164.801 72.168 164.248 72.168C163.695 72.168 163.246 72.6166 163.246 73.1701C163.246 73.7236 163.695 74.1723 164.248 74.1723Z"
          fill="#CCCCCC"
        />
        <Path
          d="M187.012 116.177C187.896 116.177 188.613 115.46 188.613 114.575C188.613 113.691 187.896 112.974 187.012 112.974C186.127 112.974 185.41 113.691 185.41 114.575C185.41 115.46 186.127 116.177 187.012 116.177Z"
          fill="#CCCCCC"
        />
        <Path
          d="M205.248 95.0949C205.759 95.0949 206.174 94.6806 206.174 94.1695C206.174 93.6584 205.759 93.2441 205.248 93.2441C204.737 93.2441 204.323 93.6584 204.323 94.1695C204.323 94.6806 204.737 95.0949 205.248 95.0949Z"
          fill="#CCCCCC"
        />
        <Path
          d="M211.334 114.984C211.887 114.984 212.336 114.535 212.336 113.982C212.336 113.428 211.887 112.979 211.334 112.979C210.78 112.979 210.332 113.428 210.332 113.982C210.332 114.535 210.78 114.984 211.334 114.984Z"
          fill="#CCCCCC"
        />
        <Path
          d="M348.782 70.7225C348.341 57.0819 338.998 46.3149 327.915 46.6738C303.249 47.4046 302.647 92.6373 326.461 95.8865L325.957 99.8945L333.312 99.6564L332.55 95.6894C342.129 93.572 349.183 83.0893 348.782 70.7225Z"
          fill="#FF6584"
        />
        <Path
          d="M315.649 78.2853L312.871 78.3753C311.782 73.197 311.609 67.8679 312.361 62.63L315.14 62.54C314.113 68.023 314.283 73.2714 315.649 78.2853Z"
          fill="white"
        />
        <Path
          d="M333.672 95.6276L325.337 95.8975L325.397 97.7498L333.732 97.48L333.672 95.6276Z"
          fill="#3F3D56"
        />
        <Path
          d="M365.863 82.2577C370.903 69.5747 366.635 55.9734 356.33 51.8785C333.423 42.7027 314.815 83.9351 335.353 96.4201L333.291 99.8937L340.129 102.611L341.014 98.6696C350.643 100.552 361.294 93.7564 365.863 82.2577Z"
          fill="#239C9D"
        />
        <Path
          d="M332.466 75.9664L329.882 74.9398C330.95 69.7572 332.919 64.8021 335.7 60.2998L338.283 61.3264C335.154 65.944 333.214 70.8239 332.466 75.9664Z"
          fill="white"
        />
        <Path
          d="M334.318 95.9808L333.633 97.7031L341.384 100.783L342.068 99.0607L334.318 95.9808Z"
          fill="#3F3D56"
        />
        <Path
          d="M47.1651 70.777C41.7123 58.2659 29.0513 51.7153 18.8861 56.1457C-3.76246 65.9431 12.3991 108.194 35.7275 102.41L36.7407 106.32L43.4866 103.38L41.3117 99.9761C49.4303 94.4672 52.1088 82.1197 47.1651 70.777Z"
          fill="#239C9D"
        />
        <Path
          d="M19.1749 90.0528L16.6264 91.1635C13.7001 86.7548 11.5697 81.8669 10.3322 76.7221L12.8806 75.6113C13.954 81.0852 16.052 85.899 19.1749 90.0528Z"
          fill="white"
        />
        <Path
          d="M42.332 99.5027L34.6865 102.835L35.427 104.534L43.0725 101.202L42.332 99.5027Z"
          fill="#3F3D56"
        />
        <G opacity="0.5" clipPath="url(#clip1)">
          <Path
            d="M264.296 75.2207C266.469 75.2207 268.23 73.4595 268.23 71.2871C268.23 69.1146 266.469 67.3535 264.296 67.3535C262.124 67.3535 260.363 69.1146 260.363 71.2871C260.363 73.4595 262.124 75.2207 264.296 75.2207Z"
            fill="#239C9D"
          />
          <Path
            d="M82.08 60.6194C83.6317 60.6194 84.8897 59.3614 84.8897 57.8097C84.8897 56.2579 83.6317 55 82.08 55C80.5282 55 79.2703 56.2579 79.2703 57.8097C79.2703 59.3614 80.5282 60.6194 82.08 60.6194Z"
            fill="#FF6584"
          />
          <Path
            d="M250.81 51.6194C252.361 51.6194 253.619 50.3614 253.619 48.8097C253.619 47.2579 252.361 46 250.81 46C249.258 46 248 47.2579 248 48.8097C248 50.3614 249.258 51.6194 250.81 51.6194Z"
            fill="#239C9D"
          />
          <Path
            d="M95.0046 89.2786C96.5564 89.2786 97.8143 88.0206 97.8143 86.4689C97.8143 84.9171 96.5564 83.6592 95.0046 83.6592C93.4529 83.6592 92.1949 84.9171 92.1949 86.4689C92.1949 88.0206 93.4529 89.2786 95.0046 89.2786Z"
            fill="#239C9D"
          />
          <Path
            d="M239.494 96.2463C241.046 96.2463 242.303 94.9884 242.303 93.4366C242.303 91.8849 241.046 90.627 239.494 90.627C237.942 90.627 236.684 91.8849 236.684 93.4366C236.684 94.9884 237.942 96.2463 239.494 96.2463Z"
            fill="#E6E6E6"
          />
          <Path
            d="M108.571 27.1143C111.513 27.2997 114.37 28.1796 116.906 29.6819C119.442 31.1843 121.586 33.2663 123.163 35.7574C123.604 36.4636 124.181 37.2396 123.875 38.1088C123.769 38.4421 123.552 38.7294 123.261 38.9237C122.97 39.1181 122.622 39.208 122.273 39.1787C121.839 39.0851 121.447 38.8511 121.158 38.5128C120.87 38.1744 120.7 37.7505 120.677 37.3065C120.653 36.8624 120.776 36.4229 121.027 36.0556C121.277 35.6884 121.642 35.4138 122.064 35.2744C124.105 34.404 126.163 35.7491 127.825 36.8226C131.613 39.2688 135.778 41.4809 140.367 41.7597C144.613 42.0176 149.166 40.3528 151.528 36.6707C151.941 36.0266 150.915 35.4313 150.504 36.0723C148.162 39.724 143.427 41.0355 139.31 40.4711C136.857 40.0839 134.488 39.2796 132.306 38.093C131.174 37.5058 130.077 36.8548 129.001 36.1705C127.978 35.4565 126.894 34.8347 125.761 34.3125C123.871 33.5362 121.369 33.5969 120.049 35.3842C118.817 37.0517 119.769 39.8277 121.829 40.2965C122.281 40.3856 122.748 40.3611 123.188 40.2254C123.628 40.0896 124.027 39.8468 124.35 39.5186C124.674 39.1904 124.91 38.7872 125.039 38.3451C125.168 37.903 125.185 37.4357 125.089 36.9853C124.884 36.0034 124.144 35.0425 123.572 34.2399C121.852 31.8208 119.612 29.8183 117.016 28.3799C114.42 26.9415 111.534 26.1039 108.571 25.9286C107.809 25.8909 107.811 27.0766 108.571 27.1143L108.571 27.1143Z"
            fill="#CCCCCC"
          />
          <Path
            d="M274.743 63.0059C272.772 61.7367 271.129 60.0185 269.95 57.992C268.771 55.9655 268.089 53.6883 267.96 51.3473C267.927 50.6856 267.827 49.9232 268.377 49.438C268.58 49.2479 268.842 49.1322 269.119 49.1101C269.396 49.0879 269.673 49.1605 269.904 49.3159C270.169 49.5495 270.351 49.8639 270.42 50.2107C270.489 50.5575 270.443 50.9175 270.287 51.2351C270.131 51.5527 269.876 51.8103 269.559 51.9682C269.243 52.126 268.883 52.1754 268.536 52.1086C266.781 51.9221 265.873 50.1899 265.135 48.8001C263.453 45.6332 261.417 42.4822 258.338 40.5097C255.489 38.6848 251.682 38.0761 248.614 39.7178C248.078 40.005 248.559 40.8161 249.093 40.5303C252.136 38.9021 255.932 39.8266 258.573 41.8144C260.127 43.0343 261.46 44.5112 262.515 46.1811C263.074 47.0275 263.584 47.9051 264.065 48.7971C264.499 49.6896 265.011 50.5418 265.596 51.3437C266.607 52.6154 268.368 53.5431 269.978 52.8135C270.337 52.6278 270.647 52.3609 270.884 52.034C271.121 51.707 271.278 51.3292 271.343 50.9306C271.408 50.532 271.379 50.1238 271.258 49.7386C271.137 49.3533 270.927 49.0017 270.646 48.7119C270.367 48.4749 270.033 48.3109 269.675 48.2346C269.316 48.1583 268.945 48.1721 268.593 48.2747C268.241 48.3774 267.921 48.5657 267.66 48.8228C267.399 49.0798 267.206 49.3976 267.098 49.7477C266.932 50.5707 266.929 51.4181 267.087 52.2425C267.344 54.5891 268.124 56.8483 269.369 58.8535C270.615 60.8588 272.294 62.5592 274.284 63.8294C274.799 64.1512 275.257 63.3269 274.743 63.0059L274.743 63.0059Z"
            fill="#CCCCCC"
          />
          <Path
            d="M179.928 15.0859H177.119V24.3178H179.928V15.0859Z"
            fill="#CCCCCC"
          />
          <Path
            d="M134.499 8.6431L136.452 6.69043L130.036 0.274524L128.083 2.22719L134.499 8.6431Z"
            fill="#B3B3B3"
          />
          <Path
            d="M213.498 28.0444L215.451 29.9971L221.867 23.5812L219.914 21.6285L213.498 28.0444Z"
            fill="#B3B3B3"
          />
          <Path
            d="M78 108.74L79.9526 110.692L86.3685 104.276L84.4159 102.324L78 108.74Z"
            fill="#FF6584"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_confetti">
          <Rect width="375" height="116" fill="white" />
        </ClipPath>
        <ClipPath id="clip1">
          <Rect
            width="277"
            height="122"
            fill="white"
            transform="translate(53 -4)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
